import { useEffect } from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { supabase } from '@/integrations/supabase/client';
import { useQueryClient } from '@tanstack/react-query';

export const useDashboardStatsOptimized = () => {
  const { user } = useSupabaseAuth();
  const queryClient = useQueryClient();

  // Set up real-time subscriptions
  useEffect(() => {
    if (!user) return;

    console.log('Setting up real-time dashboard stats subscriptions for user:', user.id);

    // Subscribe to multiple tables for real-time updates
    const channel = supabase
      .channel('dashboard-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'certificates',
          filter: `user_id=eq.${user.id}`
        },
        (payload) => {
          console.log('Certificate update detected:', payload);
          queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
          queryClient.invalidateQueries({ queryKey: ['certificates'] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'course_assignments',
          filter: `user_id=eq.${user.id}`
        },
        (payload) => {
          console.log('Course assignment update detected:', payload);
          queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
          queryClient.invalidateQueries({ queryKey: ['course-assignments'] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'user_module_progress',
          filter: `user_id=eq.${user.id}`
        },
        (payload) => {
          console.log('Module progress update detected:', payload);
          queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
          queryClient.invalidateQueries({ queryKey: ['user-module-progress'] });
        }
      )
      .subscribe();

    // Cleanup subscription on unmount
    return () => {
      console.log('Cleaning up dashboard stats subscriptions');
      supabase.removeChannel(channel);
    };
  }, [user, queryClient]);

  // Return empty object - this hook only sets up subscriptions
  // Actual stats data comes from other hooks/queries
  return {};
};
